// Calendar display and interaction constants
export const CALENDAR_CONSTANTS = {
    // Time grid dimensions
    HOUR_HEIGHT: 60,                    // Base pixels per hour
    MIN_HOUR_HEIGHT: 40,                // Minimum when zoomed out
    MAX_HOUR_HEIGHT: 120,               // Maximum when zoomed in
    TIME_COLUMN_WIDTH: 80,              // Width of time labels column

    // Event display
    MIN_EVENT_HEIGHT: 20,               // Minimum height for an event to be visible
    EVENT_PADDING: 4,                   // Padding inside events
    EVENT_MARGIN: 2,                    // Margin between events

    // Time constraints
    GRID_SNAP_MINUTES: 15,              // Snap to 15-minute intervals
    MIN_DURATION_MINUTES: 15,           // Minimum training duration
    MAX_DURATION_HOURS: 8,              // Maximum training duration

    // View settings
    DEFAULT_ZOOM_LEVEL: 1,              // Normal zoom (1x)
    MIN_ZOOM_LEVEL: 0.5,                // Minimum zoom (0.5x)
    MAX_ZOOM_LEVEL: 2,                  // Maximum zoom (2x)

    // Time format
    TIME_FORMAT_24H: 'HH:mm',           // 24-hour format
    TIME_FORMAT_12H: 'h:mm A',          // 12-hour format with AM/PM
    DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',

    // Animation durations
    ANIMATION_DURATION: 200,            // Default animation duration in ms
    DRAG_THRESHOLD: 5,                  // Pixels before drag starts

    // Mobile specific
    MOBILE_HOUR_HEIGHT: 80,             // Larger for touch targets
    MOBILE_TIME_COLUMN_WIDTH: 60,       // Narrower on mobile
    SWIPE_THRESHOLD: 50,                // Minimum swipe distance
};

// Calendar view modes
export const VIEW_MODES = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month', // Future enhancement
};

// Event types for styling
export const EVENT_TYPES = {
    CONFIRMED: 'confirmed',
    PENDING: 'pending',
    GROUP: 'group',
    LOCKED: 'locked',
    AVAILABLE: 'available',
};

// Z-index layers
export const Z_INDEX = {
    GRID: 1,
    AVAILABILITY: 2,
    EVENT: 10,
    EVENT_HOVER: 11,
    DRAGGING: 20,
    MODAL: 100,
};

// Default working hours (fallback)
export const DEFAULT_WORKING_HOURS = {
    start: '06:00',
    end: '22:00',
};

// Add these to the existing constants.js file

// Owner calendar specific constants
export const OWNER_CALENDAR_CONSTANTS = {
    // Booking modes
    BOOKING_MODES: {
        SINGLE: 'single',
        MULTIPLE: 'multiple'
    },

    // Event status types for owner view
    OWNER_EVENT_TYPES: {
        OWNER_CONFIRMED: 'owner-confirmed',
        OWNER_PENDING: 'owner-pending',
        LOCKED: 'locked',
        CONFIRMED_OTHER: 'confirmed-other',
        UNAVAILABLE: 'unavailable',
        PAST: 'past',
        FREE: 'free'
    },

    // CSS classes for owner events
    OWNER_EVENT_CLASSES: {
        'owner-confirmed': 'owner-event-confirmed',
        'owner-pending': 'owner-event-pending',
        'locked': 'owner-event-locked',
        'confirmed-other': 'owner-event-confirmed-other',
        'group': 'owner-event-group',
        'occupied': 'owner-event-occupied',
        'unavailable': 'owner-event-unavailable',
        'past': 'owner-event-unavailable',
        'free': 'owner-event-free',
        'free-selected': 'owner-event-free-selected'
    },

    // Default slot duration (minutes)
    DEFAULT_SLOT_DURATION: 60,

    // Maximum slots that can be selected at once
    MAX_MULTIPLE_BOOKINGS: 20,

    // Booking messages
    MESSAGES: {
        NO_TRAINER: 'Wybierz trenera',
        NO_DOG: 'Wybierz pupila',
        NO_SERVICE: 'Wybierz rodzaj treningu',
        BOOKING_SUCCESS: 'Trening zarezerwowany pomyślnie!',
        BOOKING_FAILED: 'Błąd przy rezerwacji treningu.',
        MULTIPLE_BOOKING_SUCCESS: 'Treningi zarezerwowane pomyślnie!',
        MULTIPLE_BOOKING_FAILED: 'Błąd przy rezerwacji wielu treningów.',
        CANCEL_SUCCESS: 'Trening odwołany.',
        CANCEL_FAILED: 'Błąd przy anulowaniu treningu.',
        MONTH_BLOCKED: 'Rezerwacje na ten miesiąc są zablokowane',
        NO_WORKING_HOURS: 'Brak godzin pracy'
    }
};